import demo from './demo';

export default {
    demo
}